export default __webpack_public_path__ + "static/reason_3-d885b21e8a034a7ea41d5a4e4bb446ce.png";